import React from "react";

export default function Marquee({ items, className = "" }) {
    const row = items.concat(items);
    return (
        <div data-testid="editorial-marquee" className={`overflow-hidden border-y border-[rgba(10,10,10,0.12)] py-5 ${className}`}>
            <div className="marquee-track flex w-max items-center">
                {row.map((item, i) => (
                    <span key={i} className="flex items-center">
                        <span className="font-display px-8 text-xs font-bold uppercase tracking-[0.4em] text-[#8E8D8A]">
                            {item}
                        </span>
                        <span className="h-1 w-1 rounded-full bg-[#333]" />
                    </span>
                ))}
            </div>
        </div>
    );
}
